import { Component, OnInit, Input } from '@angular/core';
import { SchedaIntense} from '../../core';
import { WgisService } from 'src/app/wgis/wgis.service';

@Component({
  selector: 'app-schedaintense-results',
  templateUrl: './schedaintense-results.component.html'
})
export class SchedaintenseResultsComponent implements OnInit {

  constructor(
    private wgis: WgisService
  ) { }

  @Input() results: SchedaIntense[] = [];

  ngOnInit() {
    window.scrollTo(0, 0)
  }
  zoomOn(scheda: SchedaIntense){
    this.wgis.showSchedaIntenseByObj(scheda);
  }
}
